export class LossReason {
  lossReason: Nullable<number> = null;
  lossReasonDescription: string = '';
  lossReasonName?: string;
}
